import { createContext } from "react";

import t from "../lib/translations.json";
import { languages, TextId } from "src/Translations";

export const LanguageContext = createContext({
  language: "en",
  setLanguage: (language: (typeof languages)[number]) => {},
  translate: (textID: TextId) => t[textID]["en"],
});
